<template>
  <div class="facial-features q-w360 q-fit">
    <question-with-error-wrap :error="getFieldsError(['comedones'])">
      <single-answer-question
        title="label.bumps"
        :value="comedones"
        :options="$options.bumpsOptions"
        dysfunction="skin-texture"
        @input="onFieldChange('comedones', $event)"
      />
    </question-with-error-wrap>
  </div>
</template>

<script>
import QuestionWithErrorWrap from '@/modules/questionnaire/new-design-components/questions/QuestionWithErrorWrap';
import SingleAnswerQuestion from '@/modules/questionnaire/new-design-components/questions/SingleAnswerQuestion';

import { stepTemplateMixin } from '@/modules/questionnaire/mixins/stepTemplateMixin';

import { AMOUNT_OPTIONS } from '@/modules/questionnaire/constants/questions';

export default {
  name: 'BumpsTemplate',
  components: { QuestionWithErrorWrap, SingleAnswerQuestion },
  bumpsOptions: AMOUNT_OPTIONS,
  mixins: [stepTemplateMixin],
  props: {
    comedones: {
      type: String,
      default: ''
    }
  }
};
</script>
